export const DEFAULT_RECAPTCHA_SESSION_RETRIES = 2;
